// External modules
import React from 'react';
import { isEmpty } from 'lodash';
import ACSelect from '../../atoms/ACSelect';

// Internal modules
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import Link from '@material-ui/core/Link';
import PreviewIcon from '@material-ui/icons/RemoveRedEyeOutlined';

import Modal from '@material-ui/core/Modal';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';

import ACButton from '../../atoms/ACButton';
import ACStatus from '../../atoms/ACStatus';
import ACUIElement from '../../atoms/ACUIElement';

import { getUIElementType, getUIElement, getMediaForUIName, openPreviewWindow } from '../../common/global';
import { getChallengeTypes } from '../../common/challenges';

import styles from './SetChallenge.module.scss';
import config from '../../../config/config';


export default class SetChallenge extends React.Component {
  onChangeChallengeType = (name, challengeType) => {
    if (isEmpty(challengeType)) return null;
    const { value = '' } = challengeType;
    this.props.onChangeChallengeFunc(name, value);
  };

  onChangeSubChallenge = (name, subChallenge) => {
    if (isEmpty(subChallenge)) return null;
    const { object = {} } = subChallenge;
    const { challenge = {}, onChangeChallengeFunc } = this.props;
    const { subChallenges = [] } = challenge;
    const index = subChallenges.findIndex((sChallenge) => {
      return sChallenge.id === object.id;
    });
    if (index >= 0) {
      return null;
    } else subChallenges.push(object);

    onChangeChallengeFunc(name, subChallenges);
  };

  onChangeChallengeStatus = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { value = 'active' } = e.target;
    this.props.onChangeChallengeFunc('status', value);
  };

  onChangeChallengeText = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { name = '', value = '' } = e.target;

    this.props.onChangeChallengeFunc(name, value);
  };

  onChangeACUIElement = (uiElement) => {
    const { challenge = {}, onChangeChallengeFunc } = this.props;
    const { uiElements = [] } = challenge;
    const { type = '', subType = '' } = uiElement;

    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) return ele.type === type && ele.subType === subType;
      else return ele.type === type;
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);
    onChangeChallengeFunc('uiElements', uiElements);
  };

  onChangeChallengeCheck = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { challenge = {}, onChangeChallengeFunc } = this.props;
    const { suitable = {} } = challenge;
    const { name = '', checked = false } = e.target;
    suitable[name] = checked;
    onChangeChallengeFunc('suitable', suitable);
  };

  onDeleteSubChallenge = (id) => {
    if (isEmpty(id)) return null;
    const { challenge = {}, onChangeChallengeFunc } = this.props;
    const { subChallenges = [] } = challenge;
    const index = subChallenges.findIndex((sChallenge) => {
      return sChallenge.id === id;
    });
    if (index >= 0) {
      subChallenges.splice(index, 1);
    } else return null;
    onChangeChallengeFunc('subChallenges', subChallenges);
  };

  onUploadACUIElementMedia = (name, s3FolderName, mediaType, file) => {
    const mediaFor = { ui: getMediaForUIName().challenge, name: name, s3FolderName: s3FolderName };
    this.props.uploadMediaFunc(mediaFor, mediaType, file);
  };

  previewSpark = (previewUrl) => {
    window.open(previewUrl);
  }

  renderChallengeTypes() {
    const { challenge = {} } = this.props;
    const { type = '' } = challenge;
    const challengeTypes = getChallengeTypes();
    const challengeType = challengeTypes.find((cT) => {
      return cT.value === type;
    });

    if (isEmpty(challengeTypes)) return <div />;

    return (
      <div className={styles.selectContainer}>
        <span className={styles.adornment}>Challenge Type</span>
        <ACSelect
          name="type"
          showLabel={false}
          options={challengeTypes}
          option={challengeType}
          optionLabel={'name'}
          optionValue={'value'}
          onChangeFunc={this.onChangeChallengeType}
        />
      </div>
    );
  }

  renderSubChallengesDropDown() {
    const { challenges = [] } = this.props;

    return (
      <div className={styles.selectContainer}>
        <span className={styles.adornment}>Sub challenge</span>
        <ACSelect
          name="subChallenges"
          maxOptions={300}
          showLabel={false}
          options={challenges}
          optionLabel={'name'}
          optionValue={'id'}
          onChangeFunc={this.onChangeSubChallenge}
        />
      </div>
    );
  }

  renderSubChallenges() {
    const { challenge = {} } = this.props;
    const { subChallenges = [] } = challenge;
    return subChallenges.map((sChallenge) => {
      return (
        <div className={styles.selectedSubChallenge} key={sChallenge.id}>
          <div>{sChallenge.name}</div>
          <div
            style={{ marginLeft: 'auto', marginRight: '0px' }}
            onClick={() => this.onDeleteSubChallenge(sChallenge.id)}
          >
            <DeleteIcon
              style={{
                color: '#FF765F',
                cursor: 'pointer',
              }}
            />
          </div>
        </div>
      );
    });
  }

  renderSuitables() {
    const { challenge = {} } = this.props;
    const { suitable = {} } = challenge;
    return (
      <div className={styles.suitable}>
        <span className={styles.title}>Suitable For</span>
        <div
          style={{
            marginTop: '20px',
          }}
        >
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  name="adults"
                  color="primary"
                  checked={suitable.adults || false}
                  onChange={this.onChangeChallengeCheck}
                />
              }
              label="Adults"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="children"
                  color="primary"
                  checked={suitable.children || false}
                  onChange={this.onChangeChallengeCheck}
                />
              }
              label="Children"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="couples"
                  color="primary"
                  checked={suitable.couples || false}
                  onChange={this.onChangeChallengeCheck}
                />
              }
              label="Couples"
            />
          </FormGroup>
        </div>
      </div>
    );
  }

  renderUIElements() {
    const mediaFor = 'challenge';
    const { challenge = {} } = this.props;

    const { uiElements = [] } = challenge;

    const introduction = getUIElement(uiElements, getUIElementType().introduction);
    const main = getUIElement(uiElements, getUIElementType().main);
    const callOut = getUIElement(uiElements, getUIElementType().callOut);
    const hint = getUIElement(uiElements, getUIElementType().hint);
    const solution = getUIElement(uiElements, getUIElementType().solution);

    return (
      <React.Fragment>
        <div className={styles.section}>
          <div className={styles.sectionHeading}>Introduction</div>
          <ACUIElement
            name="introduction"
            mediaFor={mediaFor}
            mediaName="challengeIntroduction"
            uiElement={introduction}
            onChangeACUIElementFunc={this.onChangeACUIElement}
            onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeading}>Spark</div>
          <ACUIElement
            name="main"
            mediaFor={mediaFor}
            mediaName="challengeBody"
            uiElement={main}
            onChangeACUIElementFunc={this.onChangeACUIElement}
            onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeading}>CallOut</div>
          <ACUIElement
            name="callOut"
            mediaFor={mediaFor}
            mediaName="challengeCallOut"
            uiElement={callOut}
            showBody={false}
            onChangeACUIElementFunc={this.onChangeACUIElement}
            onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeading}>Solution</div>
          <ACUIElement
            name="solution"
            mediaFor={mediaFor}
            mediaName="challengeSolution"
            uiElement={solution}
            showSubheading={false}
            onChangeACUIElementFunc={this.onChangeACUIElement}
            showSolvableChallange
            onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          />
        </div>
        <div className={styles.section}>
          <div className={styles.sectionHeading}>Hint</div>
          <ACUIElement
            name="hint"
            mediaFor={mediaFor}
            mediaName="challengeHint"
            uiElement={hint}
            showHeading={false}
            showSubheading={false}
            onChangeACUIElementFunc={this.onChangeACUIElement}
            onUploadACUIElementMediaFunc={this.onUploadACUIElementMedia}
          />
        </div>

      </React.Fragment>
    );
  }

  previewSparkClicked() {
    const { spark = {}, challenge = {} } = this.props;
    this.props.onSaveChallengeFunc(false)
    .then(() => {
      // Yes, we are doing a time out here to wait for the save to hopefully finish before opening the window.
      // The save function is buried 3 components up in a redux action.  
      // Have no way of telling when the save is done without setting up a bunch of prop flags in componentDidMount
      window.setTimeout(() => {
        openPreviewWindow({ sparkId : spark.id, challengeId : challenge.id });
      }, 1000)
    })
  }


  render() {
    const { spark = {}, challenge = {}, isModalOpen = false, onCloseFunc, onSaveChallengeFunc } = this.props;
    const launchURL = config.eeeURL + '?sparkId=' + spark.id + '&challengeId=' + challenge.id;



    function copyLaunchUrlToClipboard() {
        if (!navigator.clipboard) {
          prompt(`Failed copying URL.  Here it is`, launchURL);
          return;
        }
        navigator.clipboard.writeText(launchURL).then(function() {
          prompt(`URL saved to clipboard`, launchURL);
        }, function(err) {
          prompt(`Failed copying URL.  Here it is`, launchURL);
        });
    }

    return (
      <Modal open={isModalOpen} onClose={onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>
                <div>
                  <h3>Set Challenges</h3>
                </div>
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={onCloseFunc} />
                </div>
              </div>
              <div className={styles.middle}>
                <div className={styles.details}>
                  <span className={styles.title}>Details</span>
                  <ACStatus
                    type="spark"
                    status={challenge.status}
                    isEditable={true}
                    onChangeFunc={this.onChangeChallengeStatus}
                  />
                </div>
                <div>
                  {this.renderChallengeTypes()}
                  <TextField
                    name="name"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start" className={styles.adornment}>
                          Challenge Name
                        </InputAdornment>
                      ),
                    }}
                    className={styles.textField}
                    value={challenge.name || ''}
                    onChange={this.onChangeChallengeText}
                    placeholder=""
                  />
                  {this.renderSubChallengesDropDown()}
                  {this.renderSubChallenges()}
                  {this.renderSuitables()}
                  {this.renderUIElements()}
                </div>
              </div>
              <div className={styles.middle} >
                <div style={{ display : 'flex', flexDirection: 'row', justifyContent : 'space-around'}}>
                  <ACButton text={'Save & Close'} icon={<SaveIcon />}  onClickFunc={onSaveChallengeFunc}/>
                  <ACButton text={'Save & Preview'} icon={<PreviewIcon />}  onClickFunc={() => this.previewSparkClicked() }/>
                 </div>
                 <div style={{ marginTop : '24px', marginBottom : '32px', marginLeft : 'auto', marginRight : 'auto'}}>
                  <Link style={{ fontSize : '11px' }} href="#" onClick={() => copyLaunchUrlToClipboard()}>Copy URL</Link>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
